<!--
  -  Ekster is a microsub server
  -  Copyright (c) 2022 The Ekster authors
  -
  - This program is free software: you can redistribute it and/or modify
  - it under the terms of the GNU General Public License as published by
  - the Free Software Foundation, either version 3 of the License, or
  - (at your option) any later version.
  -
  - This program is distributed in the hope that it will be useful,
  - but WITHOUT ANY WARRANTY; without even the implied warranty of
  - MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  - GNU General Public License for more details.
  -
  - You should have received a copy of the GNU General Public License
  - along with this program.  If not, see <http://www.gnu.org/licenses/>.
  -->

<template>
  <div class="box">
    <div class="card">
      <div class="card-image" v-if="item.photo.length > 0">
        <figure class="image">
          <img :src="item.photo[0]" alt="">
        </figure>
      </div>
      <div class="card-content">
        <h3 class="title is-6" v-if="item.name" v-text="item.name"></h3>
        <div class="is-pre" v-text="item.summary"></div>
      </div>
      <div class="card-footer">
        <div class="card-footer-item">
        </div>
        <div class="card-footer-item">
          <div class="level">
            <div class="level-item">
              <small>
                <a :href="item.url" target="_new">Link</a>
                &middot;
                <a @click="like">Like</a>
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "EntryMention",
  props: ['url', 'item'],
  computed: {
    nicetime() {
      return moment(this.item.published).fromNow()
    }
  },
  methods: {
    like() {
      this.$store.dispatch('micropubPost', {
        'type': ['h-entry'],
        'properties': {
          'like-of': [this.item.url]
        },
      })
    }
  }
}
</script>

<style scoped>

</style>